/**
 * Tags Component
 * Renders a list of tags and a like count using FontAwesome icons.
 *
 * @component
 * @example
 * const tags = [{ name: "React", slug: "react" }];
 * const count = 24;
 * return <Tags data={tags} count={count} />;
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from '@fortawesome/free-regular-svg-icons';

const Tags = ({ data = [], count = 0 }) => {
    if (!data || data.length === 0) return null;

    return (
        <div className="tag-wrapper d-flex align-items-center justify-content-between">
            <ul className="tags__list d-flex align-items-start p-0 m-0" aria-label="Post tags">
                <li className="tags__label me-2">Tags:</li>
                {data.map(({ slug, name }, index) => (
                    <li key={index} className="tags__item me-2">
                        <Link
                            to={`/tag/${slug}`}
                            className="text-2 text-decoration-none"
                            aria-label={`Tag: ${name}`}
                        >
                            {name}
                        </Link>
                    </li>
                ))}
            </ul>
            <span className="tags__likes d-flex align-items-center" aria-label={`${count} likes`}>
                <FontAwesomeIcon icon={faHeart} className="me-1" />
                {count}
            </span>
        </div>
    );
};

Tags.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            slug: PropTypes.string.isRequired,
        })
    ),
    count: PropTypes.number,
};

export default Tags;
